import { useTranslate } from '@festina-life/ui/hooks'
import { typographyStyles } from '@festina-life/ui/structure'

type Props = {
  emptyReason?: string
}

export const PoliciesSectionEmptyState = ({ emptyReason }: Props) => {
  const translate = useTranslate()

  return (
    <p className={typographyStyles({ weight: 'bold', intensity: 'tertiary' })}>
      {translate('emptyState.noItems', {
        itemName: translate('pages.commitment.tabs.policies'),
      })}
      {emptyReason && `, ${emptyReason.toLocaleLowerCase()}`}
    </p>
  )
}
